import { Injectable } from '@angular/core';
import { MatDialogConfig, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ModalConfig } from './modal.config';
import { ModalComponent } from './modal.component';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { Subject, BehaviorSubject } from 'rxjs';
import { APP_Constants } from '../../app.constant';
import { GenericModalV2Component } from 'src/app/shared/common/generic-modal-v2/generic-modal-v2.component';
import { AppService } from 'src/app/app.service';

@Injectable({
    providedIn: 'root'
})
export class ModalService {
    // shipmentData: BehaviorSubject<any>;

    constructor(private router: Router, private matDialog: MatDialog, private appService: AppService) { }
    matDialogRef: MatDialogRef<any>;


    createModalBox(modal, status) {
        let modalConfig: MatDialogConfig = new ModalConfig(modal);
        if(modal?.version === 'v2'){
            this.matDialogRef = this.matDialog.open(GenericModalV2Component, modalConfig);
        } else{
            this.matDialogRef = this.matDialog.open(ModalComponent, modalConfig);
        }

        const subject = new Subject<boolean>();
        this.matDialogRef.componentInstance.subject = subject;
        this.matDialogRef.afterClosed()
            .subscribe(async response => {
                if (!response) {
                    if (status === 'ERROR' && modal.name === 'orderCancelInvalid' || modal.modalForm) {
                        return false;
                    }
                    else if (status === 401) {
                        // sessionStorage.clear();
                        // localStorage.clear();
                        if (environment.isSingleSignOn) {
                            this.appService.azureLogout();
                        } else {
                            this.router.navigateByUrl('/logout');
                        }
                    }
                    // simply the below code after confirmation of all error code for each microservice
                    else if (status === 500 || status === 403 || status === 404 || status === 503) {
                        if (modal.name === 'itemSearch' || modal.name === 'locationSearch' || modal.name ==='quotationSearch') {
                            return false;
                        }
                        //PORTALNA-6559:In case of error loop, the user should be redirected to the profile page
                        let homePage = localStorage.getItem('defaultHomepage');
                        if (homePage) {
                            if (window.location.pathname == homePage)
                                this.router.navigateByUrl('/profile');
                            else
                                this.router.navigateByUrl(homePage);
                        }
                    } else if (status === 400 ) {
                        return false;
                    }
                    else {
                        // home page
                        this.router.navigateByUrl('/profile');
                    }
                } else {
                    // this._shipmentSubject = response;
                }
            });
    }

    closeModel() {
        this.matDialogRef && this.matDialogRef.close();
    }
}
